<script>
import CRUDMixins from '../CRUDMixins';

export default {
    mixins: [CRUDMixins],
    props: {
        modelValue: {
            type: [String, Number, Array],
            default: null,
        },
        options: [Array, Object],
        label: String,
        optionValue: {
            type: String,
            default: 'value',
        },
        optionLabel: {
            type: [String],
            default: 'label',
        },
        nullOption: {
            type: Boolean,
            default: false,
        },
        disable: {
            type: Boolean,
            default: false,
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        formData: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            search_val: '',
        };
    },
    computed: {
        filteredOptions() {
            const options = this.options || [];
            if (!this.search_val) return options;

            const needle = this.search_val.toLowerCase();
            const labelColumns = Array.isArray(this.optionLabel) && this.optionLabel.length > 0
                ? this.optionLabel
                : [this.optionLabel];

            return options.filter(option => {
                const label = labelColumns
                    .map(col => String(option[col]).toLowerCase())
                    .join(' - ');

                return label.includes(needle);
            });
        },
        modelProxy: {
            get() {
                if (this.multiple) {
                    if (this.modelValue) {
                        try {
                            return JSON.parse(this.modelValue);
                        } catch (error) {
                            return [];
                        }
                    }
                    return [];
                }
                return this.modelValue;
            },
            set(newValue) {
                if (this.multiple) {
                    this.$emit('update:modelValue', JSON.stringify(newValue));
                } else {
                    this.$emit('update:modelValue', newValue);
                }
            },
        }
    },
    methods: {
        filterFn(val, update) {
            update(() => {
                this.search_val = val;
            });
        },
    },
    emits: ['update:modelValue'],
    
};
</script>

<template>
    <q-select
        v-model="modelProxy"
        use-input
        fill-input
        hide-selected
        :options="filteredOptions"
        :option-value="optionValue"
        :option-label="optionLabel"
        :label="label"
        @filter="filterFn"
        autocomplete="off"
        autocorrect="off"
        autocapitalize="off"
        spellcheck="false"
        emit-value
        map-options
        clearable
        :disable="disable"
        :multiple="multiple"
        :input-debounce="100"
    >
    </q-select>
</template>
